import {FormattedMessage} from '@pinecast/i18n';
import styled from '@pinecast/styles';

import StepHeading from './StepHeading';

const Wrapper = styled('div', {
  padding: '40px 0',
  textAlign: 'center',
});
const Copy = styled('p', {margin: 0});

const TipJarPendingVerification = () => (
  <Wrapper>
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      height="64"
      width="64"
      style={{display: 'block', margin: '0 auto 20px'}}
    >
      <g
        stroke="#44484d"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M56.61 44.74A4 4 0 0 1 52.68 48H6.82a4 4 0 0 1-3.93-4.74l4.5-24A4 4 0 0 1 11.32 16h45.87a4 4 0 0 1 3.93 4.74l-4.5 24z"
          strokeWidth="3"
        />
        <path d="M61.11 20.74L32 32 7.39 19.26" strokeWidth="3" />
      </g>
    </svg>
    <StepHeading centered>
      <FormattedMessage
        description="Heading when we have sent an email to verify the listener on the tip jar page"
        defaultMessage="An email is on its way"
      />
    </StepHeading>
    <Copy>
      <FormattedMessage
        description="Copy under the heading when we have sent an email to verify the listener on the tip jar page"
        defaultMessage="Check your inbox to continue."
      />
    </Copy>
  </Wrapper>
);

export default TipJarPendingVerification;
